import { render } from "./PlanilhasPv.vue?vue&type=template&id=202a4178"
import script from "./PlanilhasPv.vue?vue&type=script&lang=js"
export * from "./PlanilhasPv.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__